(function ($) {
	$.fn.serializeJSON = function () {
		var json = {};
		$.map($(this).serializeArray(), function (n, i) {
			json[n['name']] = n['value'];
		});
		return json;
	};
	$.fn.checkForEmail = function () {
		return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test($.trim($(this).val()));
	};
	$.fn.checkForUrl = function () {
		var urlExpression = "^(((ht|f)tp(s?))\://)?(www.|[a-zA-Z].)[a-zA-Z0-9\-\.]+\.(com|edu|gov|mil|net|org|biz|info|name|museum|us|ca|uk|au|nz|ru)(\:[0-9]+)*(/($|[a-zA-Z0-9\.\,\;\?\'\\\+&amp;%\$#\=~_\-]+))*$";
		return $(this).checkRegExp(urlExpression);
	};

	$.fn.checkRegExp = function (expression) {
		var pattern = new RegExp(expression);
		return pattern.test($.trim($(this).val()));
	};
	$.fn.isNullOrEmpty = function () {
		var value = $(this).val();
		if (value == null || value == undefined)
			return true;
		return value.length === 0;
	};
	$.fn.validateIt = function (options) {
		var result = true;
		$("[validate]:visible", $(this)).each(function (index, domElement) {
			result &= $(domElement).isValid(options);
		});
		return result;
	};
	$.fn.isValid = function (options) {
		var defaults = {
			successClass: null,
			errorClass: null
		};
		var params = $.extend({}, defaults, options);
		var value = $(this).val();
		var validateParams = $(this).attr('validate');
		var isCheckValid = validateParams != null && validateParams != '';
		validateParams = isCheckValid ? validateParams.toLowerCase() : '';
		var isRequired = isCheckValid && (validateParams.indexOf('required') > -1 || validateParams.indexOf('*') > -1);
		var isEmail = isCheckValid && (validateParams.indexOf('email') > -1 || validateParams.indexOf('@') > -1);
		var isUrl = isCheckValid && (validateParams.indexOf('url') > -1 || validateParams.indexOf('^') > -1);
		var equalTo = $(this).attr('equalTo');
		var isCheckEqualTo = equalTo != null && equalTo != '';
		var minLength = $(this).attr('minLength');
		var isCheckMinLength = minLength != null && minLength != '';
		var maxLength = $(this).attr('maxLength');
		var isCheckMaxLength = maxLength != null && maxLength != '' && maxLength > 0;
		var regExp = $(this).attr('regExp');
		var isCheckRegExp = regExp != null && regExp != '';
		var result = true;
		result &= isRequired ? !$(this).isNullOrEmpty() : true;
		result &= isEmail ? $(this).checkForEmail() : true;
		result &= isUrl ? $(this).checkForUrl() : true;
		result &= isCheckRegExp ? $(this).checkRegExp(regExp) : true;
		if (isRequired) {
			result &= isCheckMinLength ? value.length >= minLength : true;
		} else {
			result &= isCheckMinLength ? $(this).isNullOrEmpty() || value.length >= minLength : true;
		}
		result &= isCheckMaxLength ? value.length <= maxLength : true;
		result &= isCheckEqualTo ? value == $.trim($('#' + equalTo).val()) : true;
		if (!result) {
			if (params.errorClass != null) {
				$(this).addClass(params.errorClass);
			}
			if (params.successClass != null) {
				$(this).removeClass(params.successClass);
			}
		} else {
			if (params.errorClass != null) {
				$(this).removeClass(params.errorClass);
			}
			if (params.successClass != null) {
				$(this).addClass(params.successClass);
			}
		}
		return result;
	};
})(jQuery);

(function (app) {
	function setCookie(firstTime, referredBy) {
		var body = 'l=' + firstTime + '&r=' + (referredBy || '');
		app.cookie.set('a', body, 365*24);
		return body;
	}

	function getCookie() {
		var customerInfo = app.cookie.get('a'),
			info = {};
		if (!customerInfo) {
			customerInfo = setCookie(0);
		}
		if (customerInfo) {
            info = app.cookie.getParsedQueryStringValue('a');
		}
		return info;
	}

	function CustomerInfo() {
		this.info = getCookie();
		if (app.GlobalSettings.ug) {
			this.info.r = '';
			this.info.l = 1;
		} else {
			this.info.r = app.globalQueryParams['ReferredBy'] || this.info.r;
		}
		setCookie(this.info.l, this.info.r);
	}

	CustomerInfo.prototype = {
		info: {},
		clearR: function (firstTime) {
			this.info.l = firstTime;
			this.info.r = '';
			setCookie(this.info.l, this.info.r);
		}
	};

	window.customerInfo = new CustomerInfo();
})(app);

(function ($, app) {

    var recaptchaReady = null;

    var landingEventsHandler = $({}),
		popupMode,
		messageDialog,
		landingDeferred,
		landingMode = {
		    'None': 'None',
		    'Login': 'Login',
		    'Signup': 'Signup',
		    'ForgotPassword': 'ForgotPassword'
		};

    function showMessage(title, message) {
        if (messageDialog) {
            messageDialog;
        }
        window.messageDialog = app.dialog.popup({
            title: title,
            message: message
        });
    }

    function reloadPage() {
        if (popupMode) {
            if (landingDeferred) {
                landingDeferred.resolve();
                landingDeferred = null;
            } else {
                location.reload();
            }
        } else {
            window.location = app.globalUrls.returnUrl;
        }
    }

    function registred() {
        var data = arguments[1] || arguments[0];
        var regInfo = data.Value.Data;

        customerInfo.clearR(1);

        if (regInfo.Registered) {
            app.cookie.setFirstLogin();
            if (window.Pixel && window.Pixel.registrationTrack)
                window.Pixel.registrationTrack.setRegistred();
        }

        reloadPage();
    }

    var LandingView = Backbone.View.extend({
        el: '@landingForm',
        _eventNamespace: 'scrollFit',

        _scrollState: {
            step: 0,
            last: 0,
            path: 0
        },

        initialize: function () {
            _.bindAll(this);
            this._elTop = parseInt(this.$el.css('top'));
            this.render();
        },

        events: {
            'click @landingCloseBtn': 'destroy'
        },

        render: function () {
            var mode = this.$el.attr('mode');
            var visachackout = this.$el.data('vbutton');
            if (mode == landingMode.None) {
                popupMode = true;
            } else if (_.isFunction(window.Pixel && window.Pixel.events && window.Pixel.events.trigger)) {
            	window.Pixel.events.trigger('landingPageView');
            }
            this.signupView = new SignupView({ visachackout: visachackout });
            this.loginView = new LoginView();
            this.forgotPasswordView = new ForgotPasswordView();
            this.$el.append($.tmpl('baseForm')).find('@baseFormContainer').append(this.signupView.$el, this.loginView.$el, this.forgotPasswordView.$el);
            this._$closeBtn = this.$el.find('@landingCloseBtn').hide();
            this.switchMode(mode);
            this._renderedFlag = true;

            landingEventsHandler.on('switchMode', this.switchMode);

            if (popupMode) {
                landingEventsHandler.on('switchMode.' + this._eventNamespace, this._onScroll);
                landingEventsHandler.on('switchMode.' + this._eventNamespace, this._fitPopup);
            }
        },
        switchMode: function () {
            var mode = arguments[1] || arguments[0];
            this.signupView.toggle(mode == landingMode.Signup);
            this.loginView.toggle(mode == landingMode.Login);
            this.forgotPasswordView.toggle(mode == landingMode.ForgotPassword);
        },
        showPopup: function (opts) {
            !this._renderedFlag && this.render();

            this.closeBtnInit(opts);
            this._$window = $(window).on('resize.' + this._eventNamespace, this._fitPopup);

            if (!popupMode) return;

            this.popup = new Backbone.Notifier({
                modal: true,
                ms: false,
                color: '#000',
                screenOpacity: 0.3,
                zIndex: 9000,
                hideOnEnter: false,
                hideOnEscape: false,
                hideOnClick: false,
                hideOnOverlayClick: false,
                fadeInMs: 0,
                fadeOutMs: 0
            });
            if (opts && opts.mode && (opts.mode === landingMode.Login || opts.mode === landingMode.Signup)) {
                this.switchMode(opts.mode);
            } else {
                this.switchMode(landingMode[window.Pixel && window.Pixel.registrationTrack.isSomewhenRegistred() ? "Login" : "Signup"]);
            }
            this.$_popupDOM = this.popup.notify().$el.empty().append(this.$el.show());
            this.$el.css({ 'text-align': 'left' });
            this._fitPopup();
            this.delegateEvents();
        },

        closeBtnInit: function (opts) {
            if (opts && opts.closeBtn) {
                this._$closeBtn.show();
            } else {
                this._$closeBtn.hide();
            }
        },

        destroy: function () {
            if (this.popup) {
                this._renderedFlag = false;
                this.undelegateEvents();
                this.popup.destroyAll();
                this.signupView.remove();
                this.loginView.remove();
                this.forgotPasswordView.remove();
                this.$el.empty();
                this._$window.off('resize.' + this._eventNamespace);
                landingEventsHandler.off('switchMode', this.switchMode);
                landingEventsHandler.off('switchMode.' + this._eventNamespace);
                landingDeferred.reject();
            }
        },

        _fitPopup: function () {
            if (this.$el.outerHeight() - this._$window.outerHeight() + this._elTop > 0) {
                this.$el.css('top', 0);
                this._scrollState.path = 0;
                this._$window.on('scroll.' + this._eventNamespace, this._onScroll);
            } else {
                this.$el.css('top', this._elTop);
                this._$window.off('scroll.' + this._eventNamespace);
            }
        },

        _onScroll: function () {
            var pos = this._$window.scrollTop(),
                pos = pos > 0 ? pos : 0,
				containerHeight = this._$window.height(),
				elHeight = this.$el.outerHeight(),
				diffHeight = elHeight - containerHeight;

            this._scrollState.step = pos - this._scrollState.last;
            this._scrollState.last = pos;
            this._scrollState.path += this._scrollState.step;

            if (diffHeight > 0) {
                if (this._scrollState.path > diffHeight) {
                    this._scrollState.path = diffHeight;
                } else if (this._scrollState.path < 0) {
                    this._scrollState.path = 0;
                }
                this.$el.css('top', -this._scrollState.path);
            }
        }
    });

    var ForgotPasswordView = Backbone.View.extend({
        className: 'forgot-password-form test-forgot-password-form',
        events: {
            'click @goToLogin': 'goToLogin',
            'click @btnSend': 'send'
        },
        initialize: function () {
            _.bindAll(this);
            this.$el.hide();
        },
        toggle: function (isShow) {
            if (isShow && !this.ready) {
                this.$el.html($.tmpl('forgotPasswordForm'));
                this.$form = this.$('form');
                this.$txtEmail = this.$('input');
                this.ready = true;
            }
            this.$el.toggle(isShow);
        },
        send: function (e) {
            if (!this.$el.validateIt({ errorClass: "errorField" })) {
                app.dialog.error({
                	title: PageTemplates.get("_fillFormProperly"),
                	message: PageTemplates.get("js_enterEmailAddress")
                });
                this.$txtEmail.focus();
                return;
            }
            api.forgotPassword(this.$form.serializeJSON()).done(this.sent);
            e.preventDefault();
        },
        sent: function () {
            app.dialog.popup({
                title: '',
                message: PageTemplates.get("_PasswordRecovery")
            });
            this.$txtEmail.val('');
            landingEventsHandler.trigger('switchMode', landingMode.Login);
        },
        goToLogin: function (e) {
            landingEventsHandler.trigger('switchMode', landingMode.Login);
            e.preventDefault();
        }
    });

    var LoginView = Backbone.View.extend({
        className: 'login-form test-login-form',
        events: {
            'click @forgotPassword': 'forgotPassword',
            'click @btnSignup': 'signup',
            'click @btnLogin': 'login'
        },
        initialize: function () {
            _.bindAll(this);
            this.toggle(false);
        },
        toggle: function (isShow) {
            if (!this.ready) {
                this.$el.html($.tmpl('loginForm'));
                this.$form = this.$('form');
                this.ready = true;
            }
            if (!recaptchaReady && isShow) {
                recaptchaReady = recaptcha.init('recaptcha');
            }
            isShow && window.app && app.events && app.events.login.displayed();
            this.$el.toggle(isShow);
        },
        login: function (e) {
            window.app && app.events && app.events.login.click();
            if (!this.$el.validateIt({ errorClass: "errorField" })) {
                window.app && app.events && app.events.login.fields_not_filled();
                app.dialog.error({
                	title: PageTemplates.get("_fillFormProperly"),
                	message: PageTemplates.get("js_emailOrPasswordEmpty")
                });
            } else {

                var $this = this;
                var data = $this.$form.serializeJSON();

                recaptchaReady
                    .done(function() {
                        recaptcha.execute().done(function(token) {
                            data.captchaResponse = token;
                            window.app && app.events && app.events.login.signin_method();
                            api.signin(data).done($this.loginSuccess);
                        });
                    })
                    .fail(function() {
                        window.app && app.events && app.events.login.signin_customer_method();
                        api.signinCustomet(data).done($this.loginSuccess);
                    });
            }
            e.preventDefault();
        },
        loginSuccess: function () {
            window.app && app.events && app.events.login.success();
            reloadPage();
        },
        forgotPassword: function (e) {
            landingEventsHandler.trigger('switchMode', landingMode.ForgotPassword);
            e.preventDefault();
        },
        signup: function (e) {
            if (!popupMode) return;
            landingEventsHandler.trigger('switchMode', landingMode.Signup);
            e.preventDefault();
        }
    });

    var SignupView = Backbone.View.extend({
        className: 'signup-form test-signup-form',
        events: {
            'click @goToLogin': 'goToLogin',
            'click @btnSignup': 'signup'
        },
        initialize: function (opts) {
            _.bindAll(this);
            this.consentBlock = new RegistrationConsentBlock('', 'join-consent-text');
            this.visachackout = opts.visachackout;
            this.toggle(false);
        },
        toggle: function (isShow) {
            if (!this.ready) {
                this.$el.html($.tmpl('signupForm'));

                this.consentBlock.appendTo($('@registration-consent-block', this.$el));

                !this.visachackout.Enabled && this.$('@v-button-form').remove();

                this.$form = this.$('form');
                this.ready = true;
            }
            if (!recaptchaReady && isShow) {
                recaptchaReady = recaptcha.init('recaptcha');
            }
            this.$el.toggle(isShow);

            // Track registration view.
            if (isShow && !this._registrationTracked) {
                this._registrationTracked = true;
                if (_.isFunction(window.Pixel && window.Pixel.events && window.Pixel.events.trigger)) {
                	window.Pixel.events.trigger('registrationView');
                }
            }
        },
        signup: function (e) {
            var consentValues = this.consentBlock.validate('</br>');
            var formValid = this.$el.validateIt({ errorClass: "errorField" });

            !formValid && $('.errorField:first').focus();
            formValid && consentValues.message && showMessage('', consentValues.message);

            if (formValid && consentValues.tcAccepted && consentValues.emailsAccepted != null) {
                var data = $.extend({}, this.$form.serializeJSON(), {
                    parameters: consentValues,
                    invitedBy: app.globalQueryParams.get("invitedBy") || null,
                    referredBy: app.globalQueryParams.get("referredBy") || null,
                    voucherID: app.globalQueryParams.get("voucherID") || app.guidEmpty
                });

                recaptchaReady
                    .done(function() {
                        recaptcha.execute().done(function(token) {
                            data.captchaResponse = token;
                            window.app && app.events && app.events.login.signin_method();
                            api.signup(data).done(registred);
                        });
                    })
                    .fail(function() {
                        window.app && app.events && app.events.login.signin_customer_method();
                        api.signupCustomet(data).done(registred);
                    });
            }
            e.preventDefault();
        },
        goToLogin: function (e) {
            if (!popupMode) return;
            landingEventsHandler.trigger('switchMode', landingMode.Login);
            e.preventDefault();
        }
    });

    var landingView = null;
	var landingViewReady = new $.Deferred();
    $(function () {
        landingView = new LandingView();
        landingViewReady.resolve();
    });

	app.landingForm = {
        showPopup: function (opts) {
            landingDeferred = new $.Deferred();
            landingViewReady.done(function () {
                ThirdPartyAuthorization && ThirdPartyAuthorization(registred);
	            landingView ? landingView.showPopup(opts) : landingDeferred.reject();
            });
            return landingDeferred.promise();
        },
        destroy: function () {
            landingView && landingView.destroy();
        },
        mode: landingMode
    };
})(jQuery, app);